import { FieldsResponse } from "@/types/WorkflowCreate/fields"

export const UNKNOWN_ERROR = 'An unknown error occured. Please try again in some moment.'
export const CUSTOM_LABEL_CODE = "addCustomLabel"
export const ADD_CUSTOM_LABEL_FIELD_RESPONSE: FieldsResponse = {
  // Custom label for Transformation Step
  requestFields: [],
  responseFields: [
    {
      code: CUSTOM_LABEL_CODE,
      codeChain: CUSTOM_LABEL_CODE,
      description: "Type custom label as you want",
      displayName: "+ Add Custom Label",
      fields: [],
      order: 999, // just to appear at the end
      type: "STRING"
    }
  ]
}
